import React from 'react'

import { InterviewState } from '../../../api/gpt/types'
import { useI18N } from '../../../libraries/i18n/hook'
import Loading from '../layout/Loading'

type Props = { interviewStatus: InterviewState | undefined | null, color?: string }
const LoadingMessages: React.FC<Props> = ({ interviewStatus, color }) => {
  const { t } = useI18N()
  const [loadingMessageIndex, setLoadingMessageIndex] = React.useState(0)

  React.useEffect(() => {
    let interval: NodeJS.Timeout | null = null
    const currentMessages = getLoadingMessages()

    if (currentMessages.length > 0) {
      interval = setInterval(() => {
        setLoadingMessageIndex((prevIndex) => (prevIndex + 1) % currentMessages.length)
      }, 4000) // Change message every 4 seconds
    } else {
      setLoadingMessageIndex(0) // Reset index when not loading or no messages
    }

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [interviewStatus])

  const getLoadingMessages = () => {
    switch (interviewStatus) {
      case InterviewState.ASKING_MAIN:
      case InterviewState.ASKING_FOLLOWUP:
        return [
          t('interviewer.ai.loadingMessages.asking.0'),
          t('interviewer.ai.loadingMessages.asking.1'),
          t('interviewer.ai.loadingMessages.asking.2'),
          t('interviewer.ai.loadingMessages.asking.3'),
          t('interviewer.ai.loadingMessages.asking.4')
        ]
      case InterviewState.AWAITING_EVALUATION:
        return [
          t('interviewer.ai.loadingMessages.evaluating.0'),
          t('interviewer.ai.loadingMessages.evaluating.1'),
          t('interviewer.ai.loadingMessages.evaluating.2'),
          t('interviewer.ai.loadingMessages.evaluating.3'),
          t('interviewer.ai.loadingMessages.evaluating.4'),
          t('interviewer.ai.loadingMessages.evaluating.5'),
          t('interviewer.ai.loadingMessages.evaluating.6')
        ]
      default:
        return [
          t('interviewer.ai.loadingMessages.default.0'),
          t('interviewer.ai.loadingMessages.default.1')
        ]
    }
  }
  const loadingMessages = getLoadingMessages()
  const currentLoadingMessage = loadingMessages.length > 0 ? loadingMessages[loadingMessageIndex] : t('interviewer.ai.loadingMessages.default.0')
  return <Loading size='fill-container' loadingColor={color} textClassName={color ? `text-${color}` : ''} message={currentLoadingMessage} />
}

export default LoadingMessages
